import { DateType } from 'api/models';
import { PastProjectStatus, Project } from 'api/project';
import { StatusFieldOption } from 'api/tasks';

interface PhasePreview {
  phaseName: string;
  phaseId: number;
}

export interface ApiPhaseForProjectsReport {
  phaseInfo: PhasePreview[];
  projectId: number;
  phaseCount: number;
  phaseCompletedOnTimeCount: number;
  phaseCompletedLateCount: number;
}

interface TaskPreview {
  taskId: number;
  taskName: string;
}

interface TaskInfo {
  taskInfo: TaskPreview[];
  count: number;
  completedOnTimeCount: number;
  completedLateCount: number;
  incompleteCount: number;
}

interface MilestoneInfo {
  taskInfo: TaskPreview[];
  count: number;
  completedOnTimeCount: number;
  completedLateCount: number;
  incompleteCount: number;
}

export interface ApiTaskForProjectsReport {
  projectId: number;
  task?: TaskInfo;
  milestone?: MilestoneInfo;
}

interface ApiTemplatePreview {
  templateId?: number;
  templateName?: string;
}

interface ApiProjectsReportRecordAllocatedHoursInfo {
  minutes: number;
}
export interface ApiProjectsReportRecord
  extends Pick<
    Project,
    | 'projectId'
    | 'projectName'
    | 'projectOwner'
    | 'startDate'
    | 'dueDate'
    | 'customer'
    | 'budgetedHours'
  > {
  status: StatusFieldOption;
  startDateActual?: DateType;
  startingDelay?: number;
  dueDateActual?: DateType;
  endingDelay?: number;
  durationPlanned?: number;
  durationActual?: number;
  durationDifference?: number;
  trackedDifference?: number;
  template: ApiTemplatePreview;
  phase?: ApiPhaseForProjectsReport;
  task: ApiTaskForProjectsReport;
  pastProjectStatuses: PastProjectStatus[];
  averageCSAT: number;
  nonTemplateTaskCount: number;
  totalTrackedHours?: number;
  allocationInfo: ApiProjectsReportRecordAllocatedHoursInfo;
}

export interface ApiProjectsReport {
  projectReports: ApiProjectsReportRecord[];
  startDate: DateType;
  endDate: DateType;
}

export enum ApiProjectsReportExportType {
  Timeline = 'timeline',
  PhasesAndTasks = 'phases_and_tasks',
}
